import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    Autocomplete,
    ListItem,
    List,
    CircularProgress,
    FormHelperText
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import instance from "../../Utils/api";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Image from "../../Utils/getImage";
import NumberInput from "../../User/components/NumberInput";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const Catalogueorder = ({ setgetCartItems, openDialog, setOpenDialog, customerId }) => {
    const [designId, setDesignId] = useState(null);
    const [addCart, setAddCart] = useState({
        fabric: "",
        size: "",
        quantity: 1,
        fabricimg: null,
        procure: "",
        designId: "",
    });
    const [selected, setSelected] = useState({
        category: "",
        subCategory: "",
        designType: "",
    });

    const [category, setCategory] = useState([]);
    const [subCategory, setsubCategory] = useState([]);
    const [designtype, setDesignType] = useState([]);
    const [designs, setDesigns] = useState([]);
    const [loading, setLoading] = useState(false);

    const [errors, setErrors] = useState({
        fabric: "",
        size: "",
        quantity: 1,
        fabricimg: null,
        procure: "",
        designId: "",
    });

    // fetch Categorys
    const fetchCategory = async () => {
        try {
            const response = await instance.get('/Catalogue/getCategorys');
            const formatteddata = response?.data?.data?.map((cate, index) => ({
                sno: index + 1,
                category: cate?.category,
                categoryId: cate?._id
            }));

            setCategory(formatteddata || []);
        } catch (error) {
            console.log("error to fetch category:", error.message);
        }
    };

    //fetch SubCategory
    const fetchsubCategory = async (categoryId) => {
        try {
            if (!categoryId) {
                setsubCategory([]);
                return;
            }

            const response = await instance.get(`/Catalogue/getSubCategory?category=${categoryId}`);
            const formatteddata = response?.data?.data?.map((sub, index) => ({
                sno: index + 1,
                subCategory: sub?.subCategory,
                subcategoryId: sub?._id,
            }));

            setsubCategory(formatteddata || []);
        } catch (error) {
            console.log("error to fetch subcategory:", error.message);
            setsubCategory([]);
        }
    };

    // fetch Categorys
    const fetchDesignTypes = async (categoryId, subCategoryId) => {
        try {
            if (!categoryId || !subCategoryId) {
                setDesignType([]);
                return;
            }

            const response = await instance.get(`/Catalogue/getDesignType?category=${categoryId}&subCategory=${subCategoryId}`);
            const formatteddata = response?.data?.data?.map((design, index) => ({
                sno: index + 1,
                designtype: design?.design_type,
                designId: design?._id,
            }));

            setDesignType(formatteddata || []);
        } catch (error) {
            console.log("error to fetch Designs:", error.message);
            setDesignType([]);
        }
    };

    //fetch designs
    const fetchDesigns = async (category, subCategories, designType) => {
        try {
            if (!category || !subCategories || !designType) {
                setDesigns([]);
                return;
            }

            const response = await instance.get('/Catalogue/getDesign', {
                params: {
                    category,
                    subCategory: subCategories,
                    design_type: designType
                }
            });

            const formatteddata = response?.data?.data?.map((design, index) => ({
                sno: index + 1,
                designname: design?.name,
                designId: design?._id,
                designimage: design?.picture,
            }));

            setDesigns(formatteddata || []);
        } catch (error) {
            console.log("error to fetch Designs:", error.message);
        }
    };

    useEffect(() => { fetchCategory(); }, []);

    useEffect(() => { fetchsubCategory(selected.category); }, [selected.category]);

    useEffect(() => { fetchDesignTypes(selected.category, selected.subCategory); }, [selected.subCategory]);

    useEffect(() => { fetchDesigns(selected.category, selected.subCategory, selected.designType); }, [selected.designType]);


    // Validation function
    const validateForm = () => {
        let errors = {};

        if (!selected.category) errors.category = "Please select a Category";
        if (!selected.subCategory) errors.subCategory = "Please select a Subcategory";
        if (!selected.designType) errors.designType = "Please select a Design Type";
        if (!designId) errors.designId = "Please select a Design";

        if (!addCart.size) errors.size = "Please select a size";
        if (!addCart.fabric) errors.fabric = "Please select fabric option";
        if (!addCart.quantity) errors.quantity = "Please enter a quantity";

        if (addCart.fabric === "No" && !addCart.procure) {
            errors.procure = "Please select whether we should Procure fabric";
        }

        if (addCart.fabric === "Yes" && !addCart.fabricimg) {
            errors.fabricimg = "Please upload your Fabric image";
        }

        setErrors(errors);

        return Object.keys(errors).length === 0;
    };


    //addtocart
    const handlecartFabricImageChange = (e) => {
        const file = e.target.files[0];
        setAddCart({
            ...addCart,
            fabricimg: file,
        });
        setErrors({ ...errors, fabricimg: "" });
    };

    //handle close
    const handleClose = () => {
        setOpenDialog(false);
        setAddCart({
            fabric: "",
            size: "",
            quantity: 1,
            fabricimg: null,
            procure: "",
            designId: "",
        })
        setDesignId(null);
        setSelected({ category: "", subCategory: "", designType: "" });
        setErrors({
            fabric: "",
            size: "",
            quantity: 1,
            fabricimg: null,
            procure: "",
            designId: "",
        });

    };


    // handleAddtoCart
    const handleAddtoCart = async () => {
        if (!validateForm()) {
            return;
        }

        try {
            setLoading(true)
            const formData = new FormData();
            formData.append("customer_id", customerId);
            const item = {
                design_kind: "Design",
                fabric_given: addCart.fabric === "Yes" ? true : false,
                size: addCart.size,
                quantity: addCart.quantity,
                design_id: designId,
                procure: addCart?.procure === "Yes" ? true : false
            };
            formData.append("item", JSON.stringify(item));

            if (addCart.fabricimg) {
                formData.append("fabric_img", addCart.fabricimg);
            }
            const response = await instance.patch('/Cart/addToCart', formData)
            if (response.data.success === true) {
                toast.success(response?.data?.message)
                handleClose();
                setgetCartItems(true)
            } else {
                toast.error(response?.data?.message)
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openDialog}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Add to Catalogue Order
                    <Typography>
                        Add items to the catalogue to place an order.
                    </Typography>
                </DialogTitle>
                <hr style={{ margin: "06px 0px" }} />
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <section className="add-admin">
                        <Grid container spacing={2}>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                <div className="admin-textfiled">
                                    <FormControl fullWidth required error={Boolean(errors.category)}>
                                        <InputLabel>Select Category</InputLabel>
                                        <Select
                                            label="Select Category"
                                            value={selected.category}
                                            onChange={(e) => {
                                                setSelected({ category: e.target.value, subCategory: "", designType: "" });
                                                setErrors({ ...errors, category: "" });
                                            }}
                                        >
                                            {category?.map((item) => (
                                                <MenuItem key={item.categoryId} value={item.categoryId}>
                                                    {item.category}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {errors.category && <FormHelperText>{errors.category}</FormHelperText>}
                                    </FormControl>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                <div className="admin-textfiled">
                                    <FormControl fullWidth required error={Boolean(errors.subCategory)}>
                                        <InputLabel>Select SubCategory</InputLabel>
                                        <Select
                                            label="Select SubCategory"
                                            disabled={!selected.category}
                                            value={selected.subCategory}
                                            onChange={(e) => {
                                                setSelected({ ...selected, subCategory: e.target.value, designType: "" });
                                                setErrors({ ...errors, subCategory: "" });
                                            }}
                                        >
                                            {subCategory?.map((item) => (
                                                <MenuItem key={item.subcategoryId} value={item.subcategoryId}>
                                                    {item.subCategory}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {errors.subCategory && (<FormHelperText>{errors.subCategory}</FormHelperText>)}
                                    </FormControl>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                <div className="admin-textfiled">
                                    <FormControl fullWidth required error={Boolean(errors.designType)}>
                                        <InputLabel>Select Design Type</InputLabel>
                                        <Select
                                            label="Select Design Type"
                                            disabled={!selected.subCategory}
                                            value={selected.designType}
                                            onChange={(e) => {
                                                setSelected({ ...selected, designType: e.target.value });
                                                setErrors({ ...errors, designType: "" });
                                            }}
                                        >
                                            {designtype?.map((item) => (
                                                <MenuItem key={item.designId} value={item.designId}>
                                                    {item.designtype}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {errors.designType && (<FormHelperText>{errors.designType}</FormHelperText>)}
                                    </FormControl>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                <div className="admin-textfiled-1">
                                    <Autocomplete
                                        fullWidth
                                        disablePortal
                                        options={designs}
                                        value={designs.find((design) => design.designId === designId) || null}
                                        getOptionLabel={(option) => option.designname}
                                        onChange={(event, value) => {
                                            setDesignId(value?.designId || null);
                                            setErrors({ ...errors, designId: "" });
                                        }}
                                        disabled={!selected.designType}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                required
                                                label="Select Design"
                                                error={Boolean(errors.designId)}
                                                helperText={errors.designId}
                                            />
                                        )}
                                        renderOption={(props, option) => (
                                            <div className="menu-items-user">
                                                <Image
                                                    src={option.designimage[0]}
                                                    alt={option.designname}
                                                    width={40}
                                                    height={40}
                                                />
                                                <List>
                                                    <ListItem {...props} key={option.designId}>
                                                        {option.designname}
                                                    </ListItem>
                                                </List>
                                            </div>
                                        )}
                                    />
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                <div className="admin-textfiled">
                                    <FormControl fullWidth required error={Boolean(errors.size)}>
                                        <InputLabel id="demo-simple-select-label8">
                                            Size
                                        </InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Size"
                                            value={addCart?.size}
                                            onChange={(e) => {
                                                setAddCart({ ...addCart, size: e.target.value });
                                                setErrors({ ...errors, size: "" });
                                            }}
                                            required
                                        >
                                            {["S", "M", "L", "XL", "XXL", "XXXL"].map((size) => (
                                                <MenuItem key={size} value={size}>{size}</MenuItem>
                                            ))}
                                        </Select>
                                        {errors.size && (<FormHelperText>{errors.size}</FormHelperText>)}
                                    </FormControl>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                <div className="admin-textfiled">
                                    <FormControl fullWidth required error={Boolean(errors.fabric)}>
                                        <InputLabel id="demo-simple-select-label10">
                                            Do you have fabric?
                                        </InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select10"
                                            label="Do you have fabric?"
                                            value={addCart?.fabric}
                                            onChange={(e) => {
                                                setAddCart({ ...addCart, fabric: e.target.value });
                                                setErrors({ ...errors, fabric: "" });
                                            }}
                                            required
                                        >
                                            <MenuItem value="Yes">Yes</MenuItem>
                                            <MenuItem value="No">No</MenuItem>
                                        </Select>
                                        {errors.fabric && (<FormHelperText>{errors.fabric}</FormHelperText>)}
                                    </FormControl>
                                </div>
                            </Grid>
                            {addCart?.fabric === "No" &&
                                <>
                                    <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                        <div className="admin-textfiled">
                                            <FormControl fullWidth required error={Boolean(errors.procure)}>
                                                <InputLabel id="demo-simple-select-label">
                                                    Do you want us to Procure ?
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    label="Do you want us to Procure ?"
                                                    value={addCart.procure}
                                                    onChange={(e) => {
                                                        setAddCart({ ...addCart, procure: e.target.value });
                                                        setErrors({ ...errors, procure: "" });
                                                    }}
                                                    required
                                                >
                                                    <MenuItem value="Yes">Yes</MenuItem>
                                                    <MenuItem value="No">No</MenuItem>
                                                </Select>
                                                {errors.procure && (<FormHelperText>{errors.procure}</FormHelperText>)}
                                            </FormControl>
                                        </div>
                                    </Grid>
                                </>}
                            {addCart.fabric === "Yes" &&
                                <>
                                    <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
                                        <div className="admin-textfiled">
                                            <TextField
                                                type="file"
                                                label="Upload Fabric"
                                                accept="image/*"
                                                InputLabelProps={{ shrink: true }}
                                                onChange={handlecartFabricImageChange}
                                                required
                                                inputProps={{ accept: "image/*" }}
                                                error={Boolean(errors.fabricimg)}
                                                helperText={errors.fabricimg}
                                            />
                                        </div>
                                    </Grid>
                                </>}

                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                <div className="admin-textfiled">
                                    <InputLabel id="demo-simple-select-label1">
                                        Enter Quantity
                                    </InputLabel>
                                    <NumberInput
                                        label="Quantity"
                                        required
                                        labelId="demo-simple-select-label1"
                                        value={addCart.quantity}
                                        onChange={(event, newValue) => {
                                            if (newValue >= 1 && newValue <= 100) {
                                                setAddCart({ ...addCart, quantity: newValue });
                                                setErrors({ ...errors, quantity: "" });
                                            }
                                        }}
                                        min={1}
                                        max={100}
                                        error={Boolean(errors.quantity)}
                                    />
                                    {/* {errors.quantity && (<FormHelperText>{errors.quantity}</FormHelperText>)} */}
                                </div>
                            </Grid>
                        </Grid>
                    </section>
                </DialogContent>
                <DialogActions>
                    <Button className="cancel-btn" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button className="add-btn" disabled={loading} onClick={handleAddtoCart}>
                        {loading ? <CircularProgress size={20} color="#fff" /> : "Add to Cart"}
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment >
    )
}

export default Catalogueorder;